import { useContext } from 'react';
import { XingFrameContext } from '@xingternal/xing-frame-provider';

const useXingFrame = () => {
  const context = useContext(XingFrameContext);

  return context;
};

export { useXingFrame };
